import type { ReactNode } from 'react'
import { useRef, useState } from 'react'
import { useElementSizeRef, useThrottle } from '@jotta/hooks'
import { cn } from '@jotta/utils/css'
import Debug from 'debug'
import type { Rect } from '@jotta/types/Dimensions'
const log = Debug('jotta:ui:AnimateHeight')

export function AnimateHeight({
  className,
  innerClassName,
  children,
}: {
  className?: string
  innerClassName?: string
  children: ReactNode
}) {
  const [height, setHeight] = useState(-1)
  const ref = useRef<HTMLDivElement>(null)

  const throttledCallback = useThrottle(
    (rect: Rect) => {
      const { height } = rect
      setHeight(height)
      log(height)
    },
    30,
    { leading: false },
  )

  useElementSizeRef(ref, throttledCallback)

  return (
    <div
      className={cn('overflow-hidden transition-[height]', className)}
      style={{
        height: height >= 0 ? height : 'auto',
      }}
    >
      <div ref={ref} className={innerClassName}>
        {children}
      </div>
    </div>
  )
}
